module.exports = __webpack_public_path__ + "static/media/bicycle.dbabc46b.svg";